import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { BookOpen } from 'lucide-react';
import { useSubject } from '../../contexts/SubjectContext';
import { useTranslation } from '../../hooks/useTranslation';

const subjects = [
  { code: 'rw', nameKey: 'rechnungswesen' },
  { code: 'bw', nameKey: 'betriebswirtschaft' },
];

export default function SubjectSwitcher({ user }) {
  const { subject, setSubject } = useSubject();
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  // Only show if user has access to both subjects
  if (!user || !user.has_rechnungswesen || !user.has_betriebswirtschaft) {
    return null;
  }

  const getSubjectName = (code) => {
    return t.subjects?.[subjects.find(s => s.code === code)?.nameKey] || code.toUpperCase();
  };

  return (
    <Dropdown drop="up">
      <Dropdown.Toggle
        as="button"
        className="d-flex align-items-center gap-3 w-100 rounded px-3 py-2"
        style={{
          backgroundColor: isHovered ? "var(--bg-active)" : "var(--bg-hover)",
          color: "var(--text-primary)",
          border: "none",
          cursor: "pointer",
          transition: "background-color 0.2s ease",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <BookOpen size={22} />
        <span>{getSubjectName(subject)}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {subjects.map((s) => (
          <Dropdown.Item
            key={s.code}
            onClick={() => setSubject(s.code)}
            active={subject === s.code}
          >
            {getSubjectName(s.code)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
